import { AxiosError, AxiosResponse } from 'axios'

type ResponseError = {
  status?: string
  message?: string
}

export class HandleResponseFunctions {
  static async handleResponseError(error: AxiosError<ResponseError>): Promise<AxiosResponse<ResponseError>> {
    return Promise.reject(error)
  }
}
